import axios from 'axios'
import global from '@/assets/js/global.js'
const encryptionJS = require('@/assets/js/encryption');
const systemType = 'other'
// 配置axios实例
const http = axios.create({
  baseURL: '/api'
})
const exportZip = axios.create({
  baseURL: '/api',
  responseType: 'blob'
})
// 登录
const loginFn = function name(params, obj) {
  return axios.create({
    baseURL: '/api',
    auth: params,
    headers: {
      "signature": encryptionJS.generateSignature(encryptionJS.dataSort(obj)),
      'X-Requested-With': 'XMLHttpRequest',
      'X-Requested-System': systemType,
      'X-CAPTCHA-TOKEN': params.captchaCode
    }
  })
}

// request拦截器
exportZip.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null
    if (token) {
      config.headers['X-Auth-Token'] = token
    }

    if (config.method === 'get' || config.method === 'GET') {
      let obj = {
        timestamp: new Date().getTime()
      }
      let params = config.params
      if (params && typeof params === "object" && !Array.isArray(params)) {
        obj = Object.assign(obj, params)
      }
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.params = encryptionJS.dataSort(obj)
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['x-client'] = 'PC_LOGIN'
    config.headers['X-Requested-System'] = systemType
    return config
  },
  err => {
    return Promise.reject(err)
  })
// request拦截器
http.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null
    if (token) {
      config.headers['X-Auth-Token'] = token
    }
    if (config.method === 'get' || config.method === 'GET') {
      let obj = {
        timestamp: new Date().getTime()
      }
      let params = config.params
      if (params && typeof params === "object" && !Array.isArray(params)) {
        obj = Object.assign(obj, params)
      }
      config.headers['signature'] = encryptionJS.generateSignature(encryptionJS.dataSort(obj))
      config.params = encryptionJS.dataSort(obj)
    }
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['X-Requested-System'] = systemType
    return config
  },
  err => {
    return Promise.reject(err)
  })
// 请求结束后
http.interceptors.response.use(function (response) {
  return encryptionJS.responseHandle(response)
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
    }
  }

  return Promise.reject(error)
})
export { http, exportZip }

// 登录
export const login = params => {
  let obj = {
    timestamp: new Date().getTime()
  }
  return loginFn(params, obj).get('/oauth2/v1/token?timestamp=' + obj.timestamp).then(response => response)
}

// 获取验证码
export const getCode = params => {
  return http.get('/captcha/v1/code', { params: params }).then(response => response)
}
// 获取小程序码
export const getQrcode = params => {
  return exportZip.post('/wx/' + params.appId + '/v1/qrcode', params.data).then(response => response)
}
// 新闻查询page
export const articlePage = params => {
  params.systemType = global.systemType
  params.isPublic = true
  params.isWebsite = true
  params.status = '04'
  return http.get('/sys/article/v1/page', { params: params }).then(response => response)
}
// 新闻查询search
export const articleSearch = params => {
  return http.get('/sys/article/v1/search', { params: params }).then(response => response)
}
// 查询代表信息Page
export const representativePage = params => {
  return http.get('/cppcc-member/rep/page', { params: params }).then(response => response)
}
// 查询代表信息search
export const representativeSearch = params => {
  return http.get('/cppcc-member/rep/search', { params: params }).then(response => response)
}
// 新闻导航查询page
export const navigationPage = params => {
  return http.get('/sys/navigation/v1/page', { params: params }).then(response => response)
}
// 代表之家新闻发布查询
export const findNewsRelease = params => {
  return http.get('/congress-station/newsRelease/findNewsRelease', { params: params }).then(response => response.data)
}
// 查询联络站
export const getLiaisonPage = params => {
  return http.get('/congress-station/liaison/v1/stations/page', { params: params }).then(response => response.data)
}

export const getTenantSearch = params => {
  return http.get('/auth/tenants/v1/search', { params: params }).then(response => response)
}
// 获取上传文件认证
export const getUploadAuthentication = params => {
  return http.get('/sys/files/v1/policy', { params: params }).then(response => response)
}
// 上传文件
export const fileUpload = params => {
  return http.post(params.url, params.obj).then(response => response)
}

// 删除文件
export const fileDelete = params => {
  return http.post('/sys/files/v1/remove', params).then(response => response)
}

// 查询角色
export const authGroups = params => {
  return http.get('/auth/groups/v1/search', { params: params }).then(response => response)
}
// 提交信访
export const petitionAdd = params => {
  return http.post('/congress-petition/petitions/v1/add', params).then(response => response)
}

// 查询数据字典search
export const dictionarySearch = params => {
  return http.get('/sys/settings/v1/search', { params: params }).then(response => response)
}
// 友情链接查询
export const friendlyLinksSearch = params => {
  return http.get('/sys/settings/links/v1/search', { params: params }).then(response => response)
}

// 我向代表提意见
export const repopinionAdd = params => {
  return http.post('/congress-station/leave/message/v1/addLeavingMessage', params).then(response => response)
}

// 发送短信
export const smsCodeSend = params => {
  return http.get('/sys/sms/v1/code/send', { params: params }).then(response => response)
}
// 验证短信
export const smsCodeCheck = params => {
  return http.post('/sys/sms/v1/code/check', params).then(response => response)
}
// 查询留言
export const getStationPage = params => {
  return http.get('/congress-station/leave/message/v1/page', { params: params }).then(response => response)
}
// 提交建言
export const adviceAdd = params => {
  return http.post('/congress-system/advice/v1', params).then(response => response)
}


// 查询征集公告page
export const announcementPage = params => {
  return http.get('/platform-opinions/announcement/v1/page', { params: params }).then(response => response)
}

// 查询建言page
export const suggestionsPage = params => {
  return http.get('/platform-opinions/suggestions/v1/page', { params: params }).then(response => response)
}
// 查询建言Search
export const suggestionsSearch = params => {
  return http.get('/platform-opinions/suggestions/v1/search', { params: params }).then(response => response)
}

// 子建言查询page
export const suggestionsHandlePage = params => {
  return http.get('/platform-opinions/suggestions/handle/v1/page', { params: params }).then(response => response)
}
// 添加热议
export const heatedDebateAdd = params => {
  return http.post('/congress-party/heated/debate/v1', params).then(response => response)
}

// 查询热议
export const heatedDebatePage = params => {
  return http.get('/congress-party/heated/debate/v1/page', { params }).then(response => response)
}


// 添加建言
export const suggestionsAdd = params => {
  return http.post('/platform-opinions/suggestions/v1', params).then(response => response)
}

// 富文本内容转换
export const getHtmlContent = params => {
  return http.post('/sys/files/v1/replace/src', params).then(response => response)
}
// 根据filename获取url
export const getFilePolicy = params => {
  return http.get('/sys/files/v1/policy', { params }).then(response => response)
}